/**
 * Token identity lookups. Portfolio weights/positions are keyed by token
 * ADDRESS (the gateway serves no symbol map with them); the universe
 * snapshot's candidates provide address -> symbol/name. When a token is not
 * in the latest snapshot the UI falls back to a shortened address — it never
 * invents a ticker.
 */

import type { UniverseCandidate, UniverseSnapshot } from '../api/types'
import { shortAddr } from './format'

export type TokenIndex = ReadonlyMap<string, UniverseCandidate>

export function buildTokenIndex(
  snapshot: UniverseSnapshot | null | undefined,
): TokenIndex {
  const map = new Map<string, UniverseCandidate>()
  for (const c of snapshot?.candidates ?? []) {
    if (c && typeof c.address === 'string') {
      map.set(c.address.toLowerCase(), c)
    }
  }
  return map
}

/** Display symbol for an address: candidate symbol, else shortened address. */
export function symbolFor(index: TokenIndex, address: string): string {
  const c = index.get(address.toLowerCase())
  return c?.symbol ? c.symbol : shortAddr(address)
}

/** Display name for an address ('' when unknown). */
export function nameFor(index: TokenIndex, address: string): string {
  return index.get(address.toLowerCase())?.name ?? ''
}
